import styled from '@emotion/styled';
import { QuestionMarkRounded } from '@mui/icons-material';

export const StyledQuestionMark = styled(QuestionMarkRounded)`
  color: var(--color-scifree-teal);
  border-radius: 10px;
  font-size: 14px;
  padding: 1px;
  border: 1px solid var(--color-scifree-teal);
`;
